// extracted by mini-css-extract-plugin
module.exports = {"section":"contentSection_section__Tu9L8","richText":"contentSection_richText__djywQ","richTextFull":"contentSection_richTextFull__yJoWm"};